import { NavItemType } from 'models';
import { NavigateFunction } from 'react-router';
import { Routes } from 'utils/constants';

export const conditionalRoute = (item: NavItemType, flag: boolean) => {
  return flag ? [item] : [];
};

export const replaceDynamicPathParams = (
  path: string,
  params: { paramName: string; value?: string | bigint | number | null }[]
): string => {
  let result = path;
  params.forEach((param) => {
    const { paramName, value } = param;
    result = value ? result.replace(`:${paramName}`, value.toString()) : result;
  });
  return result;
};

export const areParamsFulfilled = (params: {
  [key: string]: string | number | undefined;
}): boolean =>
  Object.entries(params).every(
    ([key, value]) => !!value && value !== `:${key}`
  );

export const navigateToDeliveryPointPage = (
  navigateFunction: NavigateFunction,
  tenant: string | null,
  balanceGroupId: string | undefined,
  deliveryPointId: string | bigint
) => {
  const params = [
    {
      paramName: 'tenant',
      value: tenant
    },
    {
      paramName: 'balanceGroupId',
      value: balanceGroupId
    },
    {
      paramName: 'deliveryPointId',
      value: deliveryPointId
    }
  ];

  navigateFunction(
    replaceDynamicPathParams(
      Routes.DISPATCHER.ONLINE_DISPATCHING_DELIVERY_POINT_PATH,
      params
    )
  );
};

export const navigateToDevicePage = (
  navigateFunction: NavigateFunction,
  tenant: string | null,
  balanceGroupId: string | undefined,
  deviceId: string | bigint | undefined,
  deliveryPointId: string
) => {
  const params = [
    {
      paramName: 'tenant',
      value: tenant
    },
    {
      paramName: 'balanceGroupId',
      value: balanceGroupId
    },
    {
      paramName: 'deviceId',
      value: deviceId
    },
    {
      paramName: 'deliveryPointId',
      value: deliveryPointId
    }
  ];

  navigateFunction(
    replaceDynamicPathParams(
      Routes.DISPATCHER.ONLINE_DISPATCHING_DEVICE_PATH,
      params
    )
  );
};
